// Domain 05 activity widgets: the NMS console (what the monitoring server
// actually receives) — computed from live lab state on demand.
import { h } from './h.js';
import { monitoringView } from '../engine/net/services.js';
import { clone } from '../engine/net/model.js';

/** Monitoring server console: received syslog, SNMP traps and poll status per router. */
export function nmsConsole({ id, monIp, community, title = 'NMS CONSOLE · SRV-MON', limit = 14, filter = null, required = true }) {
  return {
    id, required, blocker: 'Refresh the NMS console',
    verify: () => true, // "Refresh NMS": what it shows is recomputed from the replayed network (src/core/labVerify.js)
    mount(el, rt, api) {
      const s = api.state.data;
      const render = () => {
        el.textContent = '';
        el.append(h('div', { class: 'w-title' }, title, s.t ? h('span', {}, `as of ${s.t}`) : null),
          h('div', { class: 'row' }, h('button', { class: 'btn small', 'data-testid': `nms-refresh-${id}`, onclick: () => {
            const v = monitoringView(clone(rt.net), monIp, community);
            s.view = { polled: v.polled, syslog: v.syslog.filter((e) => !filter || filter(e)).slice(-limit), traps: v.traps.slice(-6), total: v.syslog.length };
            s.t = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
            rt.action('nms-refresh', { widget: id, devices: Object.keys(v.polled).filter((k) => v.polled[k].ok), syslogFrom: [...new Set(v.syslog.map((e) => e.dev))] });
            api.done(); api.save(); render();
          } }, 'Refresh NMS')));
        if (!s.view) return;
        const v = s.view;
        el.append(h('div', { class: 'small', 'data-testid': `nms-poll-${id}` }, h('b', {}, 'SNMP polling: '),
          Object.entries(v.polled).map(([d, p]) => h('span', { class: `nms-tag ${p.ok ? 'good' : 'bad'}` }, `${d} ${p.ok ? '✓' : `✗ ${p.reason}`}`))));
        el.append(h('div', { class: 'small' }, h('b', {}, `Syslog received (${v.total} messages, latest ${v.syslog.length}):`)),
          h('pre', { class: 'nms-log', 'data-testid': `nms-log-${id}` }, v.syslog.length ? v.syslog.map((e) => `${e.dev.padEnd(5)} ${e.t}: ${e.text}`).join('\n') : '(nothing received)'));
        if (v.traps.length) el.append(h('div', { class: 'small' }, h('b', {}, 'SNMP traps: '), v.traps.map((t) => `${t.dev} ${t.text}`).join(' · ')));
      };
      render();
    },
  };
}
